import { tns } from '../../../../../../node_modules/tiny-slider/src/tiny-slider';

const element = document.querySelectorAll('[data-mobile=bankergrid-mobile]')[0];
const postsPerPage = document.getElementsByName('postsPerPage')[0];
const bankerGrid = document.querySelector('.bankergrid-container.gutter');

// If it isn't "undefined" and it isn't "null", then it exists.
if (typeof (element) !== 'undefined' && element != null) {
	const addGrid = () => {
		if (window.innerWidth < 768) {
			bankerGrid.classList.add('mobile-slider');
			postsPerPage.setAttribute('readonly', false);
			postsPerPage.value = '-1';

			document.getElementById('bankerspagination').setAttribute('hidden', true);
		} else if (window.innerWidth > 768 && bankerGrid.classList.contains('mobile-slider')) {
			bankerGrid.classList.remove('mobile-slider');
			document.getElementById('bankerspagination').setAttribute('hidden', false);
		}
	};

	addGrid();

	window.addEventListener('resize', () => {
		addGrid();
	});

	setTimeout(() => {
		tns({
			autoplay: false,
			container: element,
			controls: false,
			gutter: 20,
			items: 2,
			loop: false,
			mouseDrag: true,
			nav: true,
			navPosition: 'bottom',
			responsive: {
				768: {
					disable: true,
				},
				730: {
					fixedWidth: 430,
				},
				700: {
					fixedWidth: 400,
				},
				640: {
					fixedWidth: 350,
				},
				550: {
					fixedWidth: 340,
				},
				490: {
					fixedWidth: 300,
				},
				420: {
					fixedWidth: 250,
				},
				370: {
					fixedWidth: 230,
				},
				300: {
					fixedWidth: 200,
				},
			},
		});

		const getElementContentHeight = (elementH) => {
			const styles = window.getComputedStyle(elementH);
			const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

			return elementH.clientHeight - padding;
		};

		const bankerCardHeight = () => {
			const nodeList = document.querySelectorAll('.bankercard-wrapper');
			const els = [].slice.call(nodeList);

			const tallest = Math.max.apply(null, els.map((el) => {
				const elH = el;
				elH.style.minHeight = '';
				const elHeight = getElementContentHeight(elH);
				return elHeight;
			}));

			els.forEach((el) => {
				const elH = el;
				elH.style.minHeight = `${tallest}px`;
			});
		};

		bankerCardHeight();

		window.addEventListener('resize', () => {
			bankerCardHeight();
		});
	}, 1500);
}
